import React , { useState , useEffect, useRef } from 'react'
import lo from '../../assets/img/lo.png'
import {
        Drawer,
        DrawerBody,
        DrawerFooter,
        DrawerHeader,
        DrawerOverlay,
        DrawerContent,
        DrawerCloseButton,
        useDisclosure,
        ChakraProvider,
        Button,
        ModalOverlay 
    } from '@chakra-ui/react'
    import { CloseIcon } from '@chakra-ui/icons'
    import { Login } from '../../components/other/login/login'
    import { Link , useLocation , useNavigate } from 'react-router-dom'
    import Windows_height_width from '../../components/windows_height_width'
    import { AiOutlineHeart } from "react-icons/ai";
    import { AiOutlineShoppingCart } from "react-icons/ai";
    import { AiOutlineCalculator } from "react-icons/ai";
    
    import search_one from '../../assets/img/search_one.png'
    import { useSelector , useDispatch } from 'react-redux'
    import { Wishcount } from '../../redux/actions/productAction'

    import car from '../../assets/img/ca.png'

    import CartIcon from '../../assets/ioon/cart.png'
    import CartIcons from '../../assets/ioon/carthov.png'
    import wish from '../../assets/ioon/wish.png'


export default function Header() {
    const [productsTwo, setProductsTwo] = useState([]);
    const [specifications, setSpecifications] = useState([]);
    const [noMatchMsg, setNoMatchMsg] = useState('');
    

    const productRef = useRef(null);
    const specRef = useRef(null);
    const genRef = useRef(null);

    const [gens, setGens] = useState([]);
    const [selectedGen, setSelectedGen] = useState(null);
    const [genSearch, setGenSearch] = useState('');
    const [showGenDropdown, setShowGenDropdown] = useState(false);
    
    const [selectedProduct, setSelectedProduct] = useState(null);
    const [selectedSpec, setSelectedSpec] = useState(null);
    
    const [productSearch, setProductSearch] = useState('');
    const [specSearch, setSpecSearch] = useState('');
    
    const [showProductDropdown, setShowProductDropdown] = useState(false);
    const [showSpecDropdown, setShowSpecDropdown] = useState(false);

    const { isOpen: isCalculatorOpen, onOpen: openCalculator, onClose: closeCalculator } = useDisclosure();
      const [configSearch, setConfigSearch] = useState('');
      const configDropdownRef = useRef(null);
    
    const [calculatorData, setCalculatorData] = useState({
        numberOfItems: 1,
        rentalMonths: 12,
        selectedConfig: null,
        configurations: []
      });
 const calculations = (() => {
  if (!calculatorData.selectedConfig) {
    return {
      approximateRental: 0,
      purchaseCost: 0,
      maintenanceCost: 0,
      depreciationAmount: 0
    };
  }

  const monthlyRent = Number(calculatorData.selectedConfig.ProSpecificMonthly) || 0;
  const purchaseUnitCost = Number(calculatorData.selectedConfig.PurchaseCost) || 0;

  const qty = calculatorData.numberOfItems;
  const months = calculatorData.rentalMonths;

  const totalRentalCost = monthlyRent * qty * months;
  const totalPurchaseCost = purchaseUnitCost * qty;
  const maintenanceCost = Math.round(totalRentalCost * 0.10);
  const depreciationAmount = Math.round(totalPurchaseCost * 0.05);

  return {
    approximateRental: totalRentalCost,
    purchaseCost: totalPurchaseCost,
    maintenanceCost,
    depreciationAmount
  };
})();
    const handleCalcChange = (field, value) => {
    const updated = { ...calculatorData, [field]: value };
    setCalculatorData(updated);
  };
  const filteredConfigs = calculatorData.configurations.filter(config =>
    config.ProSpecificName.toLowerCase().includes(configSearch.toLowerCase())
  );
    const selectConfig = (config) => {
    handleCalcChange('selectedConfig', config);
    setConfigSearch('');
  };
//   useEffect(() => {
//     if (!isCalculatorOpen) return;

//     fetch("https://rentla.in/rentlanewmodule/api/ve2/fetchConfig", {
//       method: "POST",
//       headers: { "Content-Type": "application/json" }
//     })
//       .then(res => res.json())
//       .then(json => {
//         if (json.status && json.data) {
//           setCalculatorData(prev => ({
//             ...prev,
//             configurations: json.data,
//             selectedConfig: null
//           }));
//         }
//       })
//       .catch(err => console.error("Config fetch error:", err));
//   }, [isCalculatorOpen]);  
   
  useEffect(() => {
   if (!isCalculatorOpen) return;
 
   fetch("https://rentla.in/rentlanewmodule/api/ve2/proList", {
     method: "POST",
     headers: { "Content-Type": "application/json" }
   })
     .then(res => res.json())
     .then(json => {
       if (json.status) {
         setProductsTwo(json.data || []);
       }
     });
 }, [isCalculatorOpen]);
 useEffect(() => {
   if (!isCalculatorOpen) return;
 
   fetch("https://rentla.in/rentlanewmodule/api/ve2/specList", {
     method: "POST",
     headers: { "Content-Type": "application/json" }
   })
     .then(res => res.json())
     .then(json => {
       if (json.status) {
         setSpecifications(json.data || []);
         setSelectedSpec(null);
         setSpecSearch('');
       }
     });
 }, [isCalculatorOpen]);
 useEffect(() => {
   if (!isCalculatorOpen) return;
 
   fetch("https://rentla.in/rentlanewmodule/api/ve2/genList", {
     method: "POST",
     headers: { "Content-Type": "application/json" }
   })
     .then(res => res.json())
     .then(json => {
       if (json.status) {
         setGens(json.data || []);
         setSelectedGen(null);
         setGenSearch('');
       }
     });
 }, [isCalculatorOpen]);
 const filteredGens = (gens || []).filter(g =>
   (g.GenName || '').toLowerCase().includes(genSearch.toLowerCase())
 );


const filteredProducts = (productsTwo || []).filter(p =>
  (p.InventoryCatName || '')
    .toLowerCase()
    .includes(productSearch.toLowerCase())
);

const filteredSpecs = (specifications || []).filter(spec =>
  (spec.ProSpecificName || '')
    .toLowerCase()
    .includes(specSearch.toLowerCase())
);


let location = useLocation()

    const [ noo , setNo ] = useState(0)
    
    const [ search , setSearch ] = useState()

    let navigate = useNavigate()
    let dispatch = useDispatch()

    function openSearch() {
        document.getElementById("myOverlay").style.display = "block";
    }
    
    function closeSearch() {
    document.getElementById("myOverlay").style.display = "none";
    }

    const { height, width } = Windows_height_width();

    const [ wi , setWi ] = useState()

    const [ login , setlogin ] = useState(false)

    const product = useSelector((state)=>state.cartcount)

    const products = useSelector((state)=>state)

    const [ wishcountss , setWishcount ] = useState(0)

    let dyt = () =>
        {
            if(width > 1850){
                setWi(width-400)
            }else if(width > 1630){
                setWi(width-200)
            }else if(width > 1440){
                setWi(width)
            }
        }

    useEffect(()=>{
        dyt()
    },[width])

    useEffect(()=>{
        let stor = localStorage.getItem('user_data')
        let search = localStorage.getItem('search')
        
        if(location.pathname === '/search'){
            setSearch(search)
        }

        if ( stor === null ) {
            setlogin(false)
        }else{
            setlogin(true)
        }

    },[])

    useEffect(()=>{
        if(product.length !=0){
            setNo(product.products.length)
        }
    },[product])

    useEffect(() => {
      if (!selectedProduct || !selectedGen || !selectedSpec) {
        setNoMatchMsg('');
        handleCalcChange('selectedConfig', null);
        return;
      }
    
      fetch("https://rentla.in/rentlanewmodule/api/ve2/fetchAmount", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          processor_name: selectedProduct.InventoryCatName,
          gen_id: selectedGen.GenID,
          specification_name: selectedSpec.ProSpecificName
        })
      })
        .then(res => res.json())
        .then(json => {
          if (json.status && json.data) {
            setNoMatchMsg('');
            handleCalcChange('selectedConfig', {
              PurchaseCost: json.data.PurchaseCost,
              ProSpecificMonthly: json.data.MonthlyRent
            });
          } else {
            // 👇 NO MATCH
            setNoMatchMsg('No records available for this combination');
            handleCalcChange('selectedConfig', null);
          }
        })
        .catch(() => {
          setNoMatchMsg('Something went wrong. Try again.');
          handleCalcChange('selectedConfig', null);
        });
    
    }, [selectedProduct, selectedGen, selectedSpec]);
    useEffect(() => {
      const handleClickOutside = (e) => {
        if (productRef.current && !productRef.current.contains(e.target)) {
          setShowProductDropdown(false);
        }
        if (specRef.current && !specRef.current.contains(e.target)) {
          setShowSpecDropdown(false);
        }
        if (genRef.current && !genRef.current.contains(e.target)) {
          setShowGenDropdown(false);
        }
      };
    
      document.addEventListener('mousedown', handleClickOutside);
      return () => document.removeEventListener('mousedown', handleClickOutside);
    }, []);





 
    useEffect(()=>{
        //
        let wishss = localStorage.getItem('data')

        let widata = localStorage.getItem('wish_list')

        dispatch(Wishcount(JSON.parse(widata)))

        console.log(product, 'productproduct')

        if ( widata === null ){ 
            setWishcount(0)
            return
        }else if(widata === '[]'){
            setWishcount(0)
        }
        let hiis = JSON.parse(widata)

        setWishcount(hiis.length)


        if ( wishss === null ){ 
            setNo(0)
            return
        }else if(wishss === '[]'){
            setNo(0)
        }
        let hii = JSON.parse(wishss)

        setNo(hii.length)

    },[])

    const searchClicked = () =>{
        if(search === '' || search === undefined){
            return
        }else if (search === ' '){
            setSearch('')
            return
        }else{
            localStorage.setItem('search' , search)
            if(location.pathname === '/search'){
                navigate(0)
            }else{
                navigate('/search')
            }
        }
    }

    const OverlayOne = () => (
        <ModalOverlay
          bg='blackAlpha'
          backdropFilter='blur(5px) hue-rotate(90deg)'
        />
      )
    const { isOpen, onOpen, onClose } = useDisclosure()
    const btnRef = React.useRef()
    const [overlay, setOverlay] = React.useState(<OverlayOne />)

    const enterKey =(e) =>{
        if (e.key === 'Enter') {
            searchClicked()
          }
    }

    useEffect(()=>{
        if( products.wishcount.products === null || products.wishcount.products === undefined ){
            setWishcount(0)
        }else{
            setWishcount(products.wishcount.products.length)
        }
    },[products])

  return (
<>
    <header className="header-area clearfix header-hm9 transparent-bar">
        <div className='container head_containers'>
            <div className="header-top-area">
                <div className="row">
                    <div className="col-lg-2 col-md-2 col-sm-2 col-12 col-xxl-2">
                        <div style={{width:'115px'}} className="logo-hm9 text-center">
                            <Link to='/'>
                                <img className='hdddimggg' alt="logo" src={lo} />
                            </Link>
                        </div>
                    </div>

                    <div className="col-lg-8 col-md-8 col-sm-5 col-xxl-8">
                        
                    </div>
                    
                    <div className="col-lg-2 col-md-2 col-sm-2 col-12 col-xxl-2">
                        <div className="header-right-wrap">
                            <div className="same-style header-search">
                            <div class="search-container">
                                <div className='d-flex justify-content-start'>
                                    <input onKeyDown={(e)=>enterKey(e)} value={search} onChange={(e)=>{
                                         if(e.target.value === ' ')
                                         {
 
                                         }else{
                                             setSearch(e.target.value)
                                         }
                                    }} style={{background:`url${search_one}`}} className='head_search'  type="text" placeholder="Laptops, Workstation, Pc, Etc..." name="search" />
                                    <img onClick={()=>searchClicked()} className='head_search_img' src={search_one} />
                                </div>
                            </div>
                            </div>
                            <div className="same-style account-satting">
                                <Login />
                            </div>
                             {/* <div className="same-style cart-wrap">
                                                <div className="calculator-wrap">
                                                  <AiOutlineCalculator
                                                    size={28}
                                                    className="head_search_imgs"
                                                    style={{ cursor: 'pointer' }}
                                                    title="Calculator"
                                                    onClick={openCalculator}
                                                  />
                                                </div>
                                              </div> */}
                            <div className="same-style cart-wrap">
                                <div
                                //  ref={btnRef} onClick={onOpen}
                                >

                                <Link to='/cart'>
                                    <img style={{width : 30 }} src={CartIcon}   className='head_search_imgs ' />
                                    <span class='badge badge-warning' id='lblCartCount'>{noo}</span>
                                </Link>


                                </div>
                                <div className="shopping-cart-content">
                                    <ul>
                                        <li className="single-shopping-cart">
                                            <div className="shopping-cart-img">
                                                <a href="#"><img alt="" src="assets/img/cart/cart-1.png" /></a>
                                            </div>
                                            <div className="shopping-cart-title">
                                                <h4><a href="#">T- Shart & Jeans </a></h4>
                                                <h6>Qty: 02</h6>
                                                <span>$260.00</span>
                                            </div>
                                            <div className="shopping-cart-delete">
                                                <a href="#"><i className="fa fa-times-circle"></i></a>
                                            </div>
                                        </li>
                                        <li className="single-shopping-cart">
                                            <div className="shopping-cart-img">
                                                <a href="#"><img alt="" src="assets/img/cart/cart-2.png" /></a>
                                            </div>
                                            <div className="shopping-cart-title">
                                                <h4><a href="#">T- Shart & Jeans </a></h4>
                                                <h6>Qty: 02</h6>
                                                <span>$260.00</span>
                                            </div>
                                            <div className="shopping-cart-delete">
                                                <a href="#"><i className="fa fa-times-circle"></i></a>
                                            </div>
                                        </li>
                                    </ul>
                                    <div className="shopping-cart-total">
                                        <h4>Shipping : <span>$20.00</span></h4>
                                        <h4>Total : <span className="shop-total">$260.00</span></h4>
                                    </div>
                                    <div className="shopping-cart-btn btn-hover text-center">
                                        <a className="default-btn" href="cart-page.html">view cart</a>
                                        <a className="default-btn" href="checkout.html">checkout</a>
                                    </div>
                                </div>
                            </div>
                            <div className="same-style header-wishlist">
                                    <Link to="/wish">
                                        <img style={{width :30}} src={wish}  className='head_search_imgs' />
                                        <span class='badge badge-warning' id='lblCartCount'>{wishcountss}</span>
                                    </Link>
                                </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div
  className="roi-float-btn blink"
  onClick={openCalculator}
  title="ROI Calculator"
>
  ROI
</div>
    </header>
       <style>
{`
  .roi-float-btn {
    position: fixed;
    bottom: 24px;
    right: 24px;
    width: 56px;
    height: 56px;
    border-radius: 50%;
    background: #f4b644;

    color: #000;
    font-weight: 700;
    font-size: 15px;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    z-index: 9999;
    box-shadow: 0 8px 20px rgba(0,0,0,0.25);
  }

  .blink {
    animation: pulse 1.6s infinite;
  }

  @keyframes pulse {
    0% {
      transform: scale(1);
      box-shadow: 0 0 0 0 rgba(244,182,68,0.7);
    }
    70% {
      transform: scale(1.1);
      box-shadow: 0 0 0 18px rgba(244,182,68,0);
    }
    100% {
      transform: scale(1);
      box-shadow: 0 0 0 0 rgba(244,182,68,0);
    }
  }
`}
</style>

    <div id="myOverlay" className="overlay">
        <span className="closebtn" onClick={()=>closeSearch()} title="Close Overlay">×</span>
        <div className="overlay-content">
            <input type="text" placeholder="Search.." name="search" />
            <button ><i className="fa fa-search"></i></button>
        </div>
    </div>
      {/* Calculator Modal */}
      {isCalculatorOpen && (
        <div
  className="custom-modal-overlay"
  onClick={closeCalculator}
  style={{
    position: 'fixed',
    inset: 0,
    background: 'rgba(0,0,0,0.45)',
    zIndex: 9999,
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    padding: '8px'
  }}
>
          <div
  className="custom-modal-content"
  onClick={(e) => e.stopPropagation()}
  style={{
    width: '100%',
    maxWidth: '520px',
    height: '100%',
    maxHeight: '92vh',
    background: '#fff',
    borderRadius: '12px',
    display: 'flex',
    flexDirection: 'column',
    overflow: 'hidden'
  }}
>

            <div
  className="custom-modal-header"
  style={{
    position: 'sticky',
    top: 0,
    zIndex: 10,
    background: '#fff',
    padding: '16px',
    borderBottom: '1px solid #e2e8f0',
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center'
  }}
>

              <div style={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
                {/* <div style={{ width: '32px', height: '32px', backgroundColor: '#f4b644', borderRadius: '50%' }} /> */}
                <h3 style={{ margin: 0, fontSize: '20px', fontWeight: '600' }}>
                  Rental vs Purchase Calculator
                </h3>
              </div>
              <button
                onClick={closeCalculator}
                style={{ background: 'none', border: 'none', fontSize: '24px', cursor: 'pointer', color: '#999' }}
              >
                ×
              </button>
            </div>

            <div
  className="custom-modal-body"
  style={{
    flex: 1,
    overflowY: 'auto',
    padding: '16px',
    WebkitOverflowScrolling: 'touch'
  }}
>
              <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '24px' }}>
                {/* Number of Laptops */}
                <div>
                  <label style={{ display: 'block', marginBottom: '8px', fontWeight: '500' }}>
                    Number of Laptops
                  </label>
                  <div style={{ display: 'flex', alignItems: 'center', border: '2px solid #e2e8f0', borderRadius: '8px', overflow: 'hidden' }}>
                    <button onClick={() => handleCalcChange('numberOfItems', Math.max(1, calculatorData.numberOfItems - 1))}
                      style={{ padding: '12px', background: '#f7fafc', border: 'none', cursor: 'pointer' }}>−</button>
                    <input
                      type="number"
                      value={calculatorData.numberOfItems}
                      onChange={(e) => handleCalcChange('numberOfItems', Math.max(1, parseInt(e.target.value) || 1))}
                      style={{ padding: '12px', textAlign: 'center', border: 'none', width: '100%', fontSize: '18px' }}
                      min="1"
                    />
                    <button onClick={() => handleCalcChange('numberOfItems', calculatorData.numberOfItems + 1)}
                      style={{ padding: '12px', background: '#f7fafc', border: 'none', cursor: 'pointer' }}>+</button>
                  </div>
                </div>

                {/* Rental Months */}
                <div>
                  <label style={{ display: 'block', marginBottom: '8px', fontWeight: '500' }}>
                    Rental Months
                  </label>
                  <div style={{ display: 'flex', alignItems: 'center', border: '2px solid #e2e8f0', borderRadius: '8px', overflow: 'hidden' }}>
                    <button onClick={() => handleCalcChange('rentalMonths', Math.max(1, calculatorData.rentalMonths - 1))}
                      style={{ padding: '12px', background: '#f7fafc', border: 'none', cursor: 'pointer' }}>−</button>
                    <input
                      type="number"
                      value={calculatorData.rentalMonths}
                      onChange={(e) => handleCalcChange('rentalMonths', Math.max(1, parseInt(e.target.value) || 1))}
                      style={{ padding: '12px', textAlign: 'center', border: 'none', width: '100%', fontSize: '18px' }}
                      min="1"
                      max="60"
                    />
                    <button onClick={() => handleCalcChange('rentalMonths', calculatorData.rentalMonths + 1)}
                      style={{ padding: '12px', background: '#f7fafc', border: 'none', cursor: 'pointer' }}>+</button>
                  </div>
                </div>

                {/* Searchable Configuration Dropdown */}
                {/* <div style={{ gridColumn: 'span 2' }} ref={configDropdownRef}>
                  <label style={{ display: 'block', marginBottom: '8px', fontWeight: '500' }}>
                    Configuration
                  </label>
                  <div style={{ position: 'relative' }}>
                    <input
                      type="text"
                      placeholder={calculatorData.selectedConfig ? calculatorData.selectedConfig.ProSpecificName : "Search configuration..."}
                      value={configSearch}
                      onChange={(e) => setConfigSearch(e.target.value)}
                      onFocus={() => setConfigSearch('')}
                      style={{
                        width: '100%',
                        padding: '14px',
                        border: '2px solid #e2e8f0',
                        borderRadius: '8px',
                        fontSize: '16px',
                        background: calculatorData.selectedConfig ? '#f0fdf4' : 'white'
                      }}
                    />
                    {filteredConfigs.length > 0 && configSearch && (
                      <div style={{
                        position: 'absolute',
                        top: '100%',
                        left: 0,
                        right: 0,
                        background: 'white',
                        border: '2px solid #e2e8f0',
                        borderTop: 'none',
                        borderRadius: '0 0 8px 8px',
                        maxHeight: '200px',
                        overflowY: 'auto',
                        zIndex: 10
                      }}>
                        {filteredConfigs.map((config, index) => (
                          <div
                            key={index}
                            onClick={() => selectConfig(config)}
                            style={{
                              padding: '12px 16px',
                              cursor: 'pointer',
                              borderBottom: index < filteredConfigs.length - 1 ? '1px solid #e2e8f0' : 'none',
                              background: 'white',
                              ':hover': { background: '#f7fafc' }
                            }}
                          >
                            <div style={{ fontWeight: '500' }}>{config.ProSpecificName}</div>
                            <div style={{ fontSize: '14px', color: '#f4b644' }}>₹{config.ProSpecificMonthly}/month</div>
                          </div>
                        ))}
                      </div>
                    )}
                    {configSearch && filteredConfigs.length === 0 && (
                      <div style={{
                        position: 'absolute',
                        top: '100%',
                        left: 0,
                        right: 0,
                        padding: '12px',
                        background: 'white',
                        border: '2px solid #e2e8f0',
                        borderTop: 'none',
                        borderRadius: '0 0 8px 8px',
                        color: '#718096'
                      }}>
                        No configurations found
                      </div>
                    )}
                  </div>
                  {calculatorData.selectedConfig && !configSearch && (
                    <div style={{ marginTop: '8px', fontSize: '14px', color: '#f4b644', fontWeight: '500' }}>
                      Selected: {calculatorData.selectedConfig.ProSpecificName} — ₹{calculatorData.selectedConfig.ProSpecificMonthly}/month
                    </div>
                  )}
                </div> */}

      <div style={{ gridColumn: 'span 2' }}>
  <label style={{ fontWeight: 500 }} >Processors</label>

  <div style={{ position: 'relative' }} ref={productRef}>
    <input
      type="text"
      placeholder="Select processor"
      value={
        showProductDropdown
          ? productSearch
          : selectedProduct?.InventoryCatName || ''
      }
      onFocus={() => {
        setShowProductDropdown(true);
        setProductSearch('');
      }}
      onChange={(e) => {
        setProductSearch(e.target.value);
        setShowProductDropdown(true);
      }}
      style={{
        width: '100%',
        padding: '14px',
        border: '2px solid #e2e8f0',
        borderRadius: '8px'
      }}
    />

    {showProductDropdown && (
      <div
        style={{
          position: 'absolute',
          top: '100%',
          left: 0,
          right: 0,
          background: '#fff',
          border: '1px solid #e2e8f0',
          maxHeight: '220px',
          overflowY: 'auto',
          zIndex: 50
        }}
      >
        {filteredProducts.length > 0 ? (
          filteredProducts.map((p) => (
            <div
              key={p.InventoryCatName}
              onClick={() => {
                setSelectedProduct(p);
                setShowProductDropdown(false);
              }}
              style={{
                padding: '12px',
                cursor: 'pointer'
              }}
            >
              {p.InventoryCatName}
            </div>
          ))
        ) : (
          <div style={{ padding: '12px', color: '#999' }}>
            No processors found
          </div>
        )}
      </div>
    )}
  </div>
</div>

<div style={{ gridColumn: 'span 2' }}>
  <label style={{ fontWeight: 500 }}>Specification</label>

  <div style={{ position: 'relative' }} ref={specRef}>
    <input
      type="text"
      placeholder="Select specification"
      
      value={
        showSpecDropdown
          ? specSearch
          : selectedSpec
          ? `${selectedSpec.ProSpecificName}`
          : ''
      }
      onFocus={() => {
        setShowSpecDropdown(true);
        setSpecSearch('');
      }}
      onChange={(e) => {
        setSpecSearch(e.target.value);
        setShowSpecDropdown(true);
      }}
      style={{
        width: '100%',
        padding: '14px',
        border: '2px solid #e2e8f0',
        borderRadius: '8px',
        background:  '#fff'
      }}
    />

    {showSpecDropdown && (
      <div
        style={{
          position: 'absolute',
          top: '100%',
          left: 0,
          right: 0,
          background: '#fff',
          border: '1px solid #e2e8f0',
          maxHeight: '220px',
          overflowY: 'auto',
          zIndex: 50
        }}
      >
        {filteredSpecs.length > 0 ? (
          filteredSpecs.map((s) => (
            <div
              key={s.ProSpecificId}
              onClick={() => {
                  setSelectedSpec(s);
                  setShowSpecDropdown(false);
                  setSpecSearch('');
                }}
              style={{ padding: '12px', cursor: 'pointer' }}
            >
              <div style={{ fontWeight: 500 }}>
                {s.ProSpecificName}
              </div>
             
            </div>
          ))
        ) : (
          <div style={{ padding: '12px', color: '#999' }}>
            No specifications found
          </div>
        )}
      </div>
    )}
  </div>
</div>

<div style={{ gridColumn: 'span 2' }}>
  <label style={{ fontWeight: 500 }}>Generation</label>

  <div style={{ position: 'relative' }} ref={genRef}>
    <input
      type="text"
      placeholder="Select generation"
      
      value={
        showGenDropdown
          ? genSearch
          : selectedGen?.GenName || ''
      }
      onFocus={() => {
        setShowGenDropdown(true);
        setGenSearch('');
      }}
      onChange={(e) => {
          setGenSearch(e.target.value);
          setShowGenDropdown(true);
        }}
      style={{
        width: '100%',
        padding: '14px',
        border: '2px solid #e2e8f0',
        borderRadius: '8px',
        background: '#fff'
      }}
    />

    {showGenDropdown && (
      <div
        style={{
          position: 'absolute',
          top: '100%',
          left: 0,
          right: 0,
          background: '#fff',
          border: '1px solid #e2e8f0',
          maxHeight: '220px',
          overflowY: 'auto',
          zIndex: 50
        }}
      >
        {filteredGens.length > 0 ? (
          filteredGens.map((g) => (
            <div
              key={g.GenName}
              onClick={() => {
                setSelectedGen(g);
                handleCalcChange('selectedConfig', null);
                setShowGenDropdown(false);
              }}
              style={{ padding: '12px', cursor: 'pointer' }}
            >
              {g.GenName}
            </div>
          ))
        ) : (
          <div style={{ padding: '12px', color: '#999' }}>
            No generations found
          </div>
        )}
      </div>
    )}
  </div>
</div>

{noMatchMsg && (
  <div
    style={{
      gridColumn: 'span 2',
      padding: '12px',
      background: '#fff5f5',
      border: '1px solid #feb2b2',
      color: '#c53030',
      borderRadius: '8px',
      fontWeight: 500
    }}
  >
    {noMatchMsg}
  </div>
)}



                {/* Estimated Costs - 2x2 Grid */}
                <div style={{ gridColumn: 'span 2' }}>
                  <h4 style={{ marginBottom: '16px', color: '#4a5568' }}>Estimated Costs</h4>
                  <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '16px' }}>
                    <div style={{ background: '#f7fafc', padding: '16px', borderRadius: '8px', border: '1px solid #e2e8f0' }}>
                      <p style={{ margin: '0 0 8px 0', color: '#718096', fontSize: '14px' }}>Total Rental Cost</p>
                      <p style={{ margin: 0, fontSize: '20px', fontWeight: 'bold', color: '#f4b644' }}>
                        ₹{calculations.approximateRental.toLocaleString()}
                      </p>
                    </div>
                    <div style={{ background: '#f7fafc', padding: '16px', borderRadius: '8px', border: '1px solid #e2e8f0' }}>
                      <p style={{ margin: '0 0 8px 0', color: '#718096', fontSize: '14px' }}>Purchase Cost</p>
                      <p style={{ margin: 0, fontSize: '20px', fontWeight: 'bold', color: '#3182ce' }}>
                        ₹{calculations.purchaseCost.toLocaleString()}
                      </p>
                    </div>
                    <div style={{ background: '#f7fafc', padding: '16px', borderRadius: '8px', border: '1px solid #e2e8f0' }}>
                      <p style={{ margin: '0 0 8px 0', color: '#718096', fontSize: '14px' }}>Maintenance Cost</p>
                      <p style={{ margin: 0, fontSize: '20px', fontWeight: 'bold', color: '#38a169' }}>
                        ₹{calculations.maintenanceCost.toLocaleString()}
                      </p>
                    </div>
                    <div style={{ background: '#f7fafc', padding: '16px', borderRadius: '8px', border: '1px solid #e2e8f0' }}>
                      <p style={{ margin: '0 0 8px 0', color: '#718096', fontSize: '14px' }}>Depreciation (1st Year)</p>
                      <p style={{ margin: 0, fontSize: '20px', fontWeight: 'bold', color: '#e53e3e' }}>
                        ₹{calculations.depreciationAmount.toLocaleString()}
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>

           <div
  className="custom-modal-footer"
  style={{
    position: 'sticky',
    bottom: 0,
    background: '#fff',
    padding: '16px',
    borderTop: '1px solid #e2e8f0',
    zIndex: 10
  }}
>

              <button
                onClick={closeCalculator}
                style={{
                  padding: '12px 32px',
                  backgroundColor: '#f4b644',
                  color: 'white',
                  border: 'none',
                  borderRadius: '8px',
                  fontSize: '16px',
                  cursor: 'pointer'
                }}
              >
                Close Calculator
              </button>
            </div>
          </div>
        </div>
      )}
    <ChakraProvider>
        <Drawer
            isOpen={isOpen}
            placement='right'
            onClose={onClose}
            finalFocusRef={btnRef}
        >
            <DrawerOverlay />
            <DrawerContent>
                <DrawerCloseButton />
                <DrawerHeader>Shopping Cart</DrawerHeader>

                <DrawerBody>
                    <div className='row'>
                        <div className='col-3' style={{marginTop:'20px' ,borderRadius:'6px' , padding:'6px' , borderColor:'#ebebeb' , borderWidth:'1px' , borderStyle:'solid'}}>
                            <img width='100px'   src='https://media.istockphoto.com/photos/laptop-with-blank-screen-isolated-on-white-background-with-clipping-picture-id1157599345?k=20&m=1157599345&s=612x612&w=0&h=n6ARK2hCnQCd7JXPUvPgeFUPkuSSz26UpAQ8XTe1kPo=' />
                        </div>
                        <div style={{marginTop:'20px'}} className='col-7'>
                            <p style={{fontSize:'12px', lineHeight:'1.2'}}>Lenova i5 7th gen , 8gb ram.</p>
                            <p className='mt-1' style={{fontSize:'12px'}}>1 X 30000/-</p>
                        </div>
                        <div style={{marginTop:'20px'}} className='col-2'>
                            <CloseIcon w={3} h={3} color="#b5b5b5" />
                        </div>
                    </div>
                    <div className='row'>
                        <div className='col-3' style={{marginTop:'20px' ,borderRadius:'6px' , padding:'6px' , borderColor:'#ebebeb' , borderWidth:'1px' , borderStyle:'solid'}}>
                            <img width='100px'   src='https://media.istockphoto.com/photos/black-modern-laptop-with-open-display-picture-id1034249358?k=20&m=1034249358&s=612x612&w=0&h=BcZWqv7p9sbFjpeGU3QtIClpNOgyffmbkEMfmZ_PDXU=' />
                        </div>
                        <div style={{marginTop:'20px'}} className='col-7'>
                            <p style={{fontSize:'12px', lineHeight:'1.2'}}>Acer i5 7th gen , 8gb ram.</p>
                            <p className='mt-1' style={{fontSize:'12px'}}>1 X 30000/-</p>
                        </div>
                        <div style={{marginTop:'20px'}} className='col-2'>
                            <CloseIcon w={3} h={3} color="#b5b5b5" />
                        </div>
                    </div>
                    <div className='row'>
                        <div className='col-3' style={{marginTop:'20px' ,borderRadius:'6px' , padding:'6px' , borderColor:'#ebebeb' , borderWidth:'1px' , borderStyle:'solid'}}>
                            <img width='100px'   src='https://i.dell.com/is/image/DellContent/content/dam/ss2/product-images/dell-client-products/notebooks/inspiron-notebooks/15-3521/pdp/laptop-inspiron-15-3521-pdp-gallery-504x350-bk.psd?fmt=jpg&wid=570&hei=400' />
                        </div>
                        <div style={{marginTop:'20px'}} className='col-7'>
                            <p style={{fontSize:'12px', lineHeight:'1.2'}}>Hp i5 7th gen , 8gb ram.</p>
                            <p className='mt-1' style={{fontSize:'12px'}}>1 X 30000/-</p>
                        </div>
                        <div style={{marginTop:'20px'}} className='col-2'>
                            <CloseIcon w={3} h={3} color="#b5b5b5" />
                        </div>
                    </div>
                    <div className='row mt-4'>
                        <div  className='col-6 font-weight-bold'  >
                        <p style={{fontWeight:'500'}}>SubTotal : </p>
                        </div>
                        <div className='col-6 font-weight-bold' >
                            <p style={{float:'right' , fontWeight:'500'}}>12000/-</p>
                        </div>
                    </div>
                    <div className='mt-4'>
                        <Button style={{backgroundColor:'#F4B644' , color:'white' , float:'right' }} >Check Out</Button>
                    </div>
                </DrawerBody>

                <DrawerFooter>
                    <Button variant='outline' mr={3} onClick={onClose}>
                        Cancel
                    </Button>
                    <Button  style={{backgroundColor:'#F4B644' , color:'white' }}>View Cart</Button>
                </DrawerFooter>
            </DrawerContent>
        </Drawer>
    </ChakraProvider>

</>
  )
}

